import { render, staticRenderFns } from "./PlatformsCreate.vue?vue&type=template&id=116d9dd0&"
import script from "./PlatformsCreate.vue?vue&type=script&lang=js&"
export * from "./PlatformsCreate.vue?vue&type=script&lang=js&"
import style0 from "./PlatformsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports